import { BoardStore, langStore, translate } from "@noli/business";
import { shallowCopy } from "@noli/core";
import { useEffect, useMemo } from "react";
import { statusStore } from "@/stores/status";
import useImageWithPlaceholder from "@/modules/editor/hooks/useImageWithPlaceholder";
import { parseModelType } from "@/modules/editor/utils/meta";
import { Editor_Words } from "@/utils/lang/editor";
import { runInAction } from "mobx";
import { ModelTypes } from "@/modules/editor/constant";
import { getPreviewSrc } from "@/utils/misc";
import { getNodeDisplayWH } from "@/modules/editor/utils/misc";

export function useInpaintingImage() {
  const { inpaintingImageAlias } = statusStore;
  const lang = langStore.tgt;

  const { alias, enable: valid, placeholder } = useImageWithPlaceholder();
  const inpaintingImgNode = inpaintingImageAlias
    ? BoardStore.graph.getExistingNode(inpaintingImageAlias)
    : null;
  const imgWH = getNodeDisplayWH(inpaintingImageAlias);

  const curMeta = useMemo(
    () => (inpaintingImgNode?.type === "group" ? undefined : shallowCopy(inpaintingImgNode?.meta)),
    [inpaintingImgNode?.alias, inpaintingImgNode?.type],
  );

  const modelType = useMemo<ModelTypes | null>(() => parseModelType(curMeta) || null, [curMeta]);
  const sizeString = useMemo(() => {
    return imgWH ? `${imgWH.w} × ${imgWH.h} px` : translate(Editor_Words["general-loading"], lang);
  }, [imgWH]);

  useEffect(() => {
    console.log("valid: ", valid);
    if (valid) {
      updateInpaintingImage(alias);
    }
  }, [alias]);

  useEffect(() => {
    if (!valid) {
      // 当前选中图片被删了
      if (inpaintingImageAlias && !getPreviewSrc(inpaintingImageAlias)) {
        updateInpaintingImage(undefined);
      }
    }
  }, [valid]);

  const updateInpaintingImage = (alias?: string) => {
    runInAction(() => {
      statusStore.inpaintingImageAlias = alias ?? "";
    });
  };

  return {
    modelType,
    sizeString,
    imageNode: inpaintingImgNode,
    updateInpaintingImage,
    imagePlaceHolder: placeholder,
  };
}
